export const TABLE_COST_LIMIT_MESSAGE = "This table has reached its processing limit and we've paused analysis on the remaining documents. Contact support to increase the limit."
